<div>
    <mat-tree #treeControl
			  [dataSource]="dataSource"
			  [childrenAccessor]="childrenAccessor"
			  class="route-tree">
        <!-- This is the tree node template for leaf nodes -->
        <!-- There is inline padding applied to this node using styles.
          This padding value depends on the mat-icon-button width. -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
					   class="justify-content-space-between hover-node"
             [class.sub-route-node]="readonlyPreviewMode"
					   (mouseenter)="onHoverNode(node)"
					   (mouseleave)="onLeaveNode(node)">
          @if (filteringMode) {
            <mat-checkbox class="checklist-leaf-node"
                    [checked]="checklistSelection.isSelected(node)"
                    (change)="leafItemSelectionToggle(node)">
              <span>{{node.value}}</span>
            </mat-checkbox>
			    } @else {
            <span>{{node.value}}</span>

            @if (!readonlyPreviewMode) {
            <div class="style-preview">
              <app-line-style-editor
                [routeStyle]="node.styleOverride"
                [defaultStyle]="defaultStyle"
                (routeStyleChanged)="styleOverrideUpdated(node, $event)"
              ></app-line-style-editor>
            </div>
            } @else {
            <div class="flex-column pl-15 w-100">
              @for (item of routeConfiguration.subRouteItems; track $index) {
                <div class="flex-row justify-content-space-between">
                  <span [style.font-size.px]="12">{{ item.value }}</span>
                  <div
                    [style.width.px]="50"
                    [style.opacity]="item.style.opacity"
                    [style.height.px]="item.style.width"
                    [style.background-color]="item.style.color"
                  ></div>
                </div>
              }
            </div>
            }
			    }
        </mat-tree-node>

        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <div class="mat-tree-node justify-content-space-between hover-node"
               (mouseenter)="onHoverNode(node)"
               (mouseleave)="onLeaveNode(node)">
            <div class="flex-row align-items-center">
              <button mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'Toggle ' + node.value">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>

              @if (filteringMode) {
              <mat-checkbox [checked]="descendantsAllSelected(node)"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      (change)="itemSelectionToggle(node)">
                <span>{{node.value}}</span>
              </mat-checkbox>
              }
              @else {
                <span>{{node.value}}</span>
              }
              </div>

              @if (!filteringMode && !readonlyPreviewMode) {
                @if (getLevel(node) > 0) {
                  <div class="style-preview">
                    <div class="style-preview">
                      <app-line-style-editor
                        [routeStyle]="node.styleOverride"
                        [defaultStyle]="defaultStyle"
                        (routeStyleChanged)="styleOverrideUpdated(node, $event)"
                      ></app-line-style-editor>
                    </div>
                  </div>
                }
				      }
            </div>
            <!-- There is inline padding applied to this div using styles.
                This padding value depends on the mat-icon-button width.  -->
            <div [class.route-tree-invisible]="!treeControl.isExpanded(node)"
                 role="group">
                <ng-container matTreeNodeOutlet></ng-container>
            </div>
        </mat-nested-tree-node>
    </mat-tree>
</div>
